import { render, staticRenderFns } from "./AdvertForm.vue?vue&type=template&id=3b4688cf"
import script from "./AdvertForm.vue?vue&type=script&lang=js"
export * from "./AdvertForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports